import { UUID } from '../types'
import { columnDefinition, tableHidden } from '../../utils/decorators'
import { Strings } from '../../utils/strings'
import { LibraryItem } from './__MediaLibrary'

export class Link extends LibraryItem {
	public static title = 'Link'
	@tableHidden
	public display_text: string
	@tableHidden
	public link: string
	public content_type: UUID

	@columnDefinition({
		label: 'Available for trial'
	})
	public public_from?: Date

	@columnDefinition({
		label: 'Paper Number'
	})
	public paper_number: string

	constructor(item: any = {}) {
		super(item)

		this.link = Strings.default(item.link)
		this.display_text = Strings.default(item.display_text)
		this.content_type = Strings.default(item.content_type)
		this.paper_number = Strings.default(item.paper_number)

		if (item.public_from) {
			this.public_from = new Date(item.public_from)
		}
	}
}
